import { type ReactNode, useEffect, useState } from 'react';

import styles from './shell.module.css';

function computeScale(): { scale: number; left: number; top: number } {
  const scale = Math.min(window.innerWidth / 1920, window.innerHeight / 1080) || 1;
  return {
    scale,
    left: Math.max(0, (window.innerWidth - 1920 * scale) / 2),
    top: Math.max(0, (window.innerHeight - 1080 * scale) / 2),
  };
}

/**
 * Fixed 1920×1080 stage. On the TV it is 1:1; in desktop Chrome it is scaled to fit the
 * window (transform only, so norigin's `getBoundingClientRect` measurements stay consistent).
 */
export function Stage({ children }: { children: ReactNode }) {
  const [fit, setFit] = useState(computeScale);
  useEffect(() => {
    const onResize = () => setFit(computeScale());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return (
    <div
      className={styles.stage}
      style={{ transform: `scale(${fit.scale})`, left: fit.left, top: fit.top }}
      data-testid="stage"
    >
      {children}
    </div>
  );
}
